<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="450px"
    height="401px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 48.68 43.42"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2264669892960">
        <path
          class="fil0"
          d="M0.05 2.93c-0.09,0.63 -0.03,5.58 -0.03,6.64l0 19.96c0,0.57 -0.08,2.89 0.09,3.25 0.78,1.63 4.79,2.95 6.51,3.46 3.38,0.99 6.42,1.4 9.86,1.8 0.27,0.04 1.41,0.22 1.55,0.05 0.1,-0.12 0.01,-12.05 0,-13.21 -0.02,-4.44 -0.03,-8.87 -0.02,-13.3 0,-1.51 0.16,-1.85 -1.02,-2.3 -2.09,-0.79 -5.42,-1.7 -7.63,-2.34 -1.73,-0.51 -3.41,-1.02 -5.01,-1.64 -1.37,-0.54 -2.68,-1.13 -3.83,-2 -0.17,-0.13 -0.28,-0.31 -0.47,-0.37z"
        />
        <path
          class="fil0"
          d="M37.43 12.9c-0.05,1.03 -0.01,2.1 -0.01,3.14 0,0.51 0.11,2.78 0.01,3.09l-8.23 0c-0.34,-0.05 -7.93,-0.01 -8.17,0.04 -1.36,0.24 -1.02,1.77 -1.01,3.16 0,0.68 0,1.37 0.01,2.05 0,0.67 0.33,1.08 0.86,1.23 0.43,0.13 7.22,0.06 8.26,0.06l6.19 -0.01c0.64,0 1.47,-0.05 2.09,0.01 0.13,1.47 -0.25,5.27 0.16,5.94 0.17,0.27 0.55,0.52 1.05,0.44 0.49,-0.08 0.65,-0.4 0.92,-0.63 0.64,-0.55 1.35,-1.29 2.03,-1.89l3.98 -3.77c0.53,-0.45 1.44,-1.4 2.02,-1.89l0.8 -0.75c0.87,-1.03 -0.4,-1.92 -1.31,-2.82l-1.16 -1.17c-0.13,-0.14 -0.27,-0.23 -0.4,-0.37l-6.19 -6.3c-0.65,-0.65 -1.65,-0.52 -1.9,0.44z"
        />
        <path
          class="fil0"
          d="M32.42 33.85c0.08,0.19 0.14,5.62 0.04,5.91l-9.4 -0.03c-0.95,0.12 -5.47,-0.26 -6.67,-0.38 -4.03,-0.39 -13.01,-1.74 -16.09,-4.76 -0.11,-0.1 -0.13,-0.15 -0.27,-0.21l0.01 3.57c0.09,0.78 1.14,1.52 1.72,1.87 4.13,2.51 13.08,3.58 17.91,3.58l10.71 0c0.84,-0.01 2.8,0.12 3.45,-0.17 1.11,-0.51 1.01,-1.63 1.01,-2.54l-0.03 -10.72 -2.39 0.01 0 3.87z"
        />
        <path
          class="fil0"
          d="M11.22 6.37l0.01 -4.04 21.22 0.01 0.01 12.48 2.31 0 0 -12.31c0,-0.71 -0.01,-1.2 -0.37,-1.7 -0.76,-1.04 -2.06,-0.78 -3.34,-0.78l-26.7 0c-1.26,0 -2.5,0.24 -3.3,0.87 -1.09,0.86 0.25,1.8 1.08,2.24 1.72,0.91 3.99,1.74 5.9,2.3 0.52,0.15 1.04,0.32 1.57,0.48 0.39,0.11 1.25,0.42 1.61,0.45z"
        />
        <path
          class="fil0"
          d="M29.2 19.13l8.23 0c0.1,-0.31 -0.01,-2.58 -0.01,-3.09 0,-1.04 -0.04,-2.11 0.01,-3.14 -0.12,0.25 -0.08,0.46 -0.08,0.77 0.02,1.75 0.08,3.74 0.06,5.42 -1.32,-0.04 -2.8,-0.05 -4.12,0 -0.76,0.03 -3.64,-0.11 -4.09,0.04z"
        />
        <path
          class="fil0"
          d="M23.06 39.73l9.4 0.03c0.1,-0.29 0.04,-5.72 -0.04,-5.91l0.04 5.87 -9.4 0.01z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
